import { useState, useEffect } from "react"
import { favOptions } from "./Faves.js"

export default function ToggleFavs(movieInfo) {
    const [starState, toggleStar] = useState(false);
    const [state, toggleState] = useState(false)

    const trueStar = () => { toggleStar(!starState) };

    const movies = favOptions("GET")
    console.log(movieInfo)
    useEffect(() => {
            function toRun() {
                if (movies.hasOwnProperty(movieInfo.id.title)) {
                    toggleStar(true)
                }
            }

            toRun()
        }, [state]
    )

    if (state === false && movieInfo !== undefined) {
        toggleState(true)
    }
    
    function saveToStorage(info) {
        if (!starState === true) {
            favOptions("SET", {...movies, [`${info.title}`]: {"id": info.id, "path": info.poster_path, "title": info.title}})
        } else {
            delete movies[info.title]
            favOptions("SET", movies)
        }
    }

    return (
        <i className={"magic fa-star " + (starState ? "fa-solid" : "fa-regular")} onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            trueStar()
            saveToStorage(movieInfo.id)
        }} />
    )
}